import {Component, ElementRef, Input, ViewChild} from '@angular/core';

import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import {Converter} from 'showdown';
import { NavService } from 'shared/nav/nav.service';

import { Browser } from '@capacitor/browser';
import { HyphenateService } from 'shared/helpers/hyphenate.service';

@Component({
  selector: 'rich-text',
  templateUrl: 'rich-text.html',
  styleUrls: ['rich-text.scss'],
})
export class RichTextComponent {

  @Input()
  public contentLinks: boolean = false;

  private _loadAudio;
  @Input() public set loadAudio(loadAudio: boolean) {
    if ( this._loadAudio == false && loadAudio) {
      // activate
    }
    if ( this._loadAudio === true && loadAudio === false) {
      // ignore
    }
    else {
      this._loadAudio = loadAudio;
    }
  }

  public get loadAudio(): boolean {
    return this._loadAudio === undefined || this._loadAudio === true;
  }

  private _loadVideo;
  @Input() public set loadVideo(loadVideo: boolean) {
    if ( this._loadVideo == false && loadVideo) {
      // activate
    }
    if ( this._loadVideo === true && loadVideo === false) {
      // ignore
    }
    else {
      this._loadVideo = loadVideo;
    }
  }

  public get loadVideo(): boolean {
    return this._loadVideo === undefined || this._loadVideo === true;
  }

  public converter = null;

  public audioUrl: Array<SafeResourceUrl> = [];
  public videoUrl: Array<SafeResourceUrl> = [];
  public dialogText: Array<string> = [];

  constructor(
    private navService: NavService,
    private sanitizer: DomSanitizer,
    private hyphenateService: HyphenateService,
    ) { 
      this.converter = new Converter();
      this.converter.setFlavor('github');
    }

  private _text: string;
  @Input() public set text(text: string) {
    this._text = text;
    this.processText(text);
  }

  private _query: string = '';
  @Input() public set query(query: string) {
    this._query = query;
    if ( this._text != undefined ) {
      this.processText(this._text);
    }
  }

  private processText(text:string): void {
    // unhyphen Text
    let s = text.replace(/\u00AD/g, '');
    s = this._convertTextToMarkdown(s);
    let i = 0;
    while ( s != '' ) {
      const mPodcast = /(<a\s+href="(https:\/\/everydaycounts.podigee.io\/[^"]+)">)/i.exec(s)
      const mVideo = /(<a\s+href="(https:\/\/www.youtube.com\/embed\/[^"]+)">(([^<]*)<\/a>|))/i.exec(s);
      if ( mPodcast != null && (mVideo == null || mPodcast.index < mVideo.index) ) {
        const all: string = mPodcast[1];
        let url: string = mPodcast[2];
        url = url.replace(/\?.*/, '');
        url += '/embed?context=external&amp=false';
        this.audioUrl[i] = this.sanitizer.bypassSecurityTrustResourceUrl(url);
        this.dialogText[i] = this.hyphenateService.hyphenate(this.checkQuery(this.cleanText(s.substring(0, mPodcast.index))));
        s = s.substring(mPodcast.index+all.length);
      }
      else if (mVideo != null) {
        const all: string = mVideo[1];
        let url: string = mVideo[2];
        url = url.replace('autoplay=1', '');
        this.videoUrl[i] = this.sanitizer.bypassSecurityTrustResourceUrl(url);
        this.dialogText[i] = this.hyphenateService.hyphenate(this.checkQuery(this.cleanText(s.substring(0, mVideo.index))));
        s = s.substring(mVideo.index+all.length);
      }
      else {
        if ( i == 0 || s.replace('</p>', '').replace(/\s/g, '') != '') {
          this.dialogText[i] = this.hyphenateService.hyphenate(this.checkQuery(this.cleanText(s)));
        }
        s = '';
      }
      i++;
    }
    // console.log(" tt %o", this.dialogText);
  }

  private _convertTextToMarkdown(text: string): string {
    let s = this.converter.makeHtml(text);
    if ( !this.contentLinks ) {
      let m;
      while ( (m = /(\{content:\s*([^\}]+)\})/.exec(s)) != null ) {
        const subst = m[1];
        const name =  m[2];
        s = s.replace(subst, '<a href="https://dummy.de/'+name+'">'+name+'</a>');
      } 
    }
    return s;
  }

  private cleanText(s: string) : string {
    return s.replace(/^\s*<\/p>\s*/, '').replace(/\s*<p>\s*$/, '')
  }

  public interceptClick(event: Event): void {
    const target: HTMLElement = <HTMLElement> event.target;
    if (!(target instanceof HTMLAnchorElement) && !(target.parentElement instanceof HTMLAnchorElement)) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    const anchor: HTMLAnchorElement = <HTMLAnchorElement> (target.tagName === 'A' ? target : target.parentElement);
    const href = anchor.href;
    if ( href.indexOf('https://dummy.de/') == 0) {
      this.navService.push('content', {selContentTitle: decodeURI(href.substring(17))});
    }
    else {
      Browser.open({url: href});
    }
  }

  private checkQuery(s: string): string {
    if (this._query == '') {
      return s;
    }
    let res = '';
    while (s != '') {
      const mTag = /(<[^>]+>)/i.exec(s);
      if (mTag != null) {
        const tag: string = mTag[1];
        res += this.addQuery(s.substring(0, mTag.index)) + tag;
        s = s.substring(mTag.index+tag.length);
      }
      else {
        res += this.addQuery(s);
        s = '';
      }
    }
    return res;
  }

  private addQuery(s: string): string {
    return s.replace(new RegExp('('+this._query+')', 'i'), '<span class="mq">\$1</span>');
  }
}
